<script lang="ts">
  import { page } from "$app/stores";

  import type { Page } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";
  import {
    closeMobileMenu,
    collapsedStore,
    themeStore,
    toggleCollapsedState,
  } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";

  export let level: number = 1;
  export let showArrow = false;

  let isActive = false;
  let previousIsActive = isActive;
  let navItem: HTMLDivElement | null = null;
  let isCollapsed = false;

  export let section: Page;

  $: isActive = $page.url.pathname === section.href;

  function scrollIntoView(isActive: boolean) {
    if (navItem && isActive) {
      navItem.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  $: isCollapsed = $collapsedStore[section.href] ?? false;

  $: if (isActive !== previousIsActive) {
    scrollIntoView(isActive);
    previousIsActive = isActive;
  }
</script>

<div
  bind:this={navItem}
  class={`flex items-center pr-4 text-left ${
    showArrow ? "w-full sm:w-[400px]" : "w-full"
  }`}
  style:padding-left={`${level}rem`}
  class:bg-light-green={$page.url.pathname === section.href}
  class:text-dark-gray={$page.url.pathname === section.href}
  style:--hover-bg={$themeStore.primary[20]}
  style:--active-bg={$themeStore.primary[100]}
  style:--active-text={$themeStore.secondary[100]}
  class:active={isActive}
>
  {#if showArrow}
    <svg
      class="mr-3"
      width="18"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 2.16666H10.8333V4.33333H13V6.49997H0L0 8.66667H13V10.8334H10.8333V13H9.75V15.1667H13V13H15.1667V10.8334H17.3333V9.74997H18.4167V8.66667H19.5V6.49997H18.4167V5.41667H17.3333V4.33333H15.1667V2.16666H13V0L9.75 0V2.16666Z"
        fill="currentColor"
      />
    </svg>
  {/if}
  <a
    on:click={closeMobileMenu}
    class="flex w-full items-center gap-2 leading-6 hover:bg-transparent"
    href={section.href}
    ><span>{section.title}</span>
    {#if section.abbreviation}
      <div
        class="h-fit rounded-xs px-2 text-sm"
        style:color={isActive
          ? $themeStore.secondary[80]
          : $themeStore.primary[80]}
        style:background-color={isActive
          ? $themeStore.secondary[20]
          : $themeStore.primary[5]}
      >
        {section.abbreviation}
      </div>
    {/if}
  </a>

  {#if section.pages}
    <button
      class="ml-2 px-4 text-2xl"
      on:click={() => {
        toggleCollapsedState(section.href);
      }}
    >
      {isCollapsed ? "+" : "-"}
    </button>
  {/if}
</div>

{#if section.pages && !isCollapsed}
  {#each section.pages as subSection}
    <svelte:self section={subSection} level={level + 1} {showArrow} />
  {/each}
{/if}

<style>
  div {
    transition: background-color 0.2s;
  }

  div:hover:not(.active) {
    background-color: var(--hover-bg);
    color: var(--hover-text);
  }

  .active {
    background-color: var(--active-bg);
    color: var(--active-text);
  }
</style>
